import React from 'react';

const Circle = (props) => {
    const { color } = props;

    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 756 756"
            style={{ enableBackground: 'new 0 0 756 756', width: '100%' }}
            xmlSpace="preserve"
        >
            <circle style={{ fill: `${color}` }} cx="378" cy="378" r="368.6" />
        </svg>
    );
};

export default Circle;
